
import { ItemType } from '@/common/bot/lib';
import { BaseNotice } from '@/common/bot/types';
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class SystemNotice extends Vue {
  @Prop({ default: () => ({}) }) readonly notice!: BaseNotice;

  get text () {
    return ItemType.isNotice(this.notice) ? this.notice.message : '';
  }
}
